export enum AccessPermissionRoles {
    BusinessRegistry = 'BUSINESS_REGISTRY',
    Self = 'SELF',
    Full = 'FULL',
    Limited = 'LIMITED'
}
